module.exports = __webpack_public_path__ + "img/18a001-03.997910f8.png";